import React from 'react';
import { Link } from 'react-router-dom';
import { useWebsiteContent } from '../WebsiteContentContext';

export const About = () => {
  const c = useWebsiteContent();
  return (
    <div data-testid="page-about">
      {/* Hero */}
      <section className="relative pt-16 pb-20 bg-gradient-to-br from-slate-50 via-white to-blue-50/40 overflow-hidden">
        <div className="absolute inset-0 opacity-[0.04]" style={{ backgroundImage: 'radial-gradient(circle at 1px 1px, #0f172a 1px, transparent 0)', backgroundSize: '24px 24px' }} />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
          <div className="max-w-3xl">
            <span className="text-xs uppercase tracking-[0.25em] font-semibold text-blue-600">{c.about_eyebrow}</span>
            <h1 className="mt-4 text-5xl sm:text-6xl font-bold tracking-tight text-slate-900 leading-[1.05]">{c.about_title}</h1>
            <p className="mt-6 text-lg text-slate-600 leading-relaxed max-w-2xl">{c.about_intro}</p>
          </div>
        </div>
      </section>

      {/* How it works */}
      <section data-testid="how-it-works" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="max-w-2xl mb-16">
            <span className="text-xs uppercase tracking-[0.25em] font-semibold text-blue-600">{c.about_how_eyebrow}</span>
            <h2 className="mt-4 text-4xl sm:text-5xl font-bold tracking-tight text-slate-900 leading-[1.1]">{c.about_how_title}</h2>
            <p className="mt-5 text-lg text-slate-600">{c.about_how_subtitle}</p>
          </div>

          <div className="relative">
            <div className="hidden md:block absolute top-12 left-[8%] right-[8%] h-px bg-gradient-to-r from-blue-200 via-blue-300 to-blue-200" />
            <div className="grid grid-cols-1 md:grid-cols-3 gap-10 relative">
              {(c.how_it_works || []).map((s, i) => (
                <div key={i} data-testid={`about-step-${i}`} className="relative bg-white">
                  <div className="w-24 h-24 rounded-2xl bg-blue-600 text-white text-3xl font-bold flex items-center justify-center shadow-lg shadow-blue-600/30 relative z-10">{s.step}</div>
                  <h3 className="mt-6 text-2xl font-bold text-slate-900">{s.title}</h3>
                  <p className="mt-3 text-slate-600 leading-relaxed">{s.body}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Mission strip */}
      <section className="py-24 bg-slate-900 text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-30" style={{ backgroundImage: 'radial-gradient(circle at 70% 20%, rgba(59,130,246,0.4) 0, transparent 50%)' }} />
        <div className="relative max-w-5xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-16">
            <div>
              <span className="text-xs uppercase tracking-[0.25em] font-semibold text-blue-300">{c.about_mission_eyebrow}</span>
              <h2 className="mt-4 text-3xl font-bold leading-tight">{c.about_mission_title}</h2>
            </div>
            <p className="lg:col-span-2 text-lg text-slate-300 leading-relaxed">{c.about_mission_body}</p>
          </div>
        </div>
      </section>

      {/* Values grid */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="max-w-2xl mb-16">
            <span className="text-xs uppercase tracking-[0.25em] font-semibold text-blue-600">{c.about_values_eyebrow}</span>
            <h2 className="mt-4 text-4xl sm:text-5xl font-bold tracking-tight text-slate-900 leading-[1.1]">{c.about_values_title}</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {(c.about_values || []).map((v, i) => (
              <div key={i} data-testid={`value-${i}`} className="p-7 rounded-2xl border border-slate-200 hover:border-blue-300 transition">
                <h3 className="text-lg font-semibold text-slate-900 mb-2">{v.title}</h3>
                <p className="text-slate-600 leading-relaxed text-sm">{v.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-gradient-to-br from-blue-600 to-blue-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="max-w-2xl">
            <h2 className="text-3xl sm:text-4xl font-bold text-white tracking-tight">See it in your own dashboard.</h2>
            <div className="mt-8 flex flex-wrap gap-3">
              <Link to="/register" data-testid="about-cta-register" className="px-7 py-4 rounded-full bg-white text-blue-700 font-semibold shadow-lg hover:bg-blue-50 transition">Start Free Trial</Link>
              <Link to="/packages" className="px-7 py-4 rounded-full bg-white/10 hover:bg-white/20 text-white font-semibold border border-white/30 transition">See packages</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
